import React from 'react'

import { Div } from 'elements/layout/Div'
import { P } from 'elements/text/P'

export const StepTitle: TFCC = ({ children }) => (
  <Div align="center" fontSize="1em" m="1em 0 1.5em" p="0 10px">
    {typeof children === 'string' ? <P bold>{children}</P> : children}
  </Div>
)
